"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "configMercadoPago", {
  enumerable: true,
  get: function () {
    return _sdk.configMercadoPago;
  }
});
Object.defineProperty(exports, "getDeviceId", {
  enumerable: true,
  get: function () {
    return _security.getDeviceId;
  }
});
exports.load = void 0;
var _security = require("./security");
var _sdk = require("./sdk");
const load = () => {
  return Promise.all([(0, _security.init)(), (0, _sdk.load)()]).then(() => {});
};
exports.load = load;